import { APP_STAGE } from '../config';

export const isDev = APP_STAGE === 'dev';
export const isStaging = APP_STAGE === 'staging';
export const isNonprod = isStaging || isDev;
